import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
function Digit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  const display = String(value).padStart(2, '0');
  return <div className="flex flex-col items-center" data-id="element-35">
      <div className="bg-white/15 backdrop-blur-sm rounded-lg px-2.5 py-1 min-w-[2.8rem] text-center" data-id="element-36">
        <span className="text-xl md:text-2xl font-black text-white tabular-nums leading-none" data-id="element-37">
          {display}
        </span>
      </div>
      <span className="text-[9px] uppercase tracking-widest text-white/60 mt-1 font-semibold" data-id="element-38">
        {label}
      </span>
    </div>;
}
export function CountdownBanner() {
  const {
    timeLeft,
    isExpired
  } = useCountdown();
  if (isExpired) {
    return <div className="w-full bg-gray-800 px-4 py-2.5 text-center" data-id="element-39">
        <p className="text-sm font-semibold text-white/80" data-id="element-40">
          This introductory offer has ended. The Advanced session is now{' '}
          <span className="text-white font-black" data-id="element-41">$5,000</span>.
        </p>
      </div>;
  }
  return <div className="w-full bg-gradient-to-r from-teal-700 via-teal-600 to-teal-700 px-4 py-2.5" data-id="element-42">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6" data-id="element-43">
        <p className="text-sm font-bold text-white/90 text-center sm:text-left" data-id="element-44">
          🔥 <span className="text-white" data-id="element-45">$1,500 offer ends in:</span>
        </p>
        <div className="flex items-end gap-2" data-id="element-46">
          <Digit value={timeLeft.days} label="days" data-id="element-47" />
          <span className="text-white/60 font-black text-xl mb-4" data-id="element-48">:</span>
          <Digit value={timeLeft.hours} label="hrs" data-id="element-49" />
          <span className="text-white/60 font-black text-xl mb-4" data-id="element-50">:</span>
          <Digit value={timeLeft.minutes} label="min" data-id="element-51" />
          <span className="text-white/60 font-black text-xl mb-4" data-id="element-52">:</span>
          <Digit value={timeLeft.seconds} label="sec" data-id="element-53" />
        </div>
        <a href="https://go.peptidescienceinstitute.com/meeting-with-the-master-advanced" className="text-xs font-bold bg-white text-teal-700 px-4 py-1.5 rounded-full hover:bg-teal-50 transition-colors whitespace-nowrap" data-id="element-54">
          Book Now →
        </a>
      </div>
    </div>;
}